import { render, staticRenderFns } from "./python-text.vue?vue&type=template&id=1f523d71&scoped=true"
import script from "./python-text.vue?vue&type=script&lang=js"
export * from "./python-text.vue?vue&type=script&lang=js"
import style0 from "./python-text.vue?vue&type=style&index=0&id=1f523d71&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f523d71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f523d71')) {
      api.createRecord('1f523d71', component.options)
    } else {
      api.reload('1f523d71', component.options)
    }
    module.hot.accept("./python-text.vue?vue&type=template&id=1f523d71&scoped=true", function () {
      api.rerender('1f523d71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/python-text.vue"
export default component.exports